<div id="faq" class="page-layout simple full-width">

    <!-- HEADER -->
    <div class="header accent p-16 p-sm-24" fxLayout="column" fxLayoutAlign="center center">
        <div class="hero-text mb-16">
            <h1>Análisis estadístico
                <span> 
                    <mat-icon>data_usage</mat-icon>
                </span>
            </h1>
        </div>
    </div>

   
   <!--
    <div class="flexContainer">
        <mat-card class="leadForm" style="width: 100%;">
            <mat-card-header>
                <mat-card-title-group>
                  <mat-card-title>FORMULARIO CAMPAÑA</mat-card-title>
                </mat-card-title-group>
            </mat-card-header>
            <mat-card-content class="flexContainer" style="flex-direction: column;">
              <div class="flexItem">
                  <mat-form-field appearance="outline">
                      <mat-label>Nombre Inmobiliaria</mat-label>
                      <input #email matInput>
                      <mat-icon matSuffix class="secondary-text">person</mat-icon>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                      <mat-label>CIF</mat-label>
                      <input #email matInput>
                      <mat-icon matSuffix class="secondary-text">card</mat-icon>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                      <mat-label>Email</mat-label>
                      <input #email matInput>
                      <mat-icon matSuffix class="secondary-text">email</mat-icon>
                  </mat-form-field>
              </div>
              <mat-label>Saludo inicial</mat-label>
              <div class="flexItem">
                  <textarea id="saludo"
                        rows="1"
                        style="width:90%; max-width: 90%; resize: none;">
                  </textarea>
              </div>
            <mat-label>Contexto Negocio</mat-label>
            <div class="flexItem">
                <textarea id="contexto"
                      rows="5"
                      style="width:90%; max-width: 90%; resize: none;">
                </textarea>
            </div>
            <mat-label>Indicadores a conocer</mat-label>
            <div class="flexItem">
                <textarea id="indicadores"
                    rows="5"
                    style="width:90%; max-width: 90%; resize: none;">
                </textarea>
            </div>
            <br>
            <br>
            <br>
            <br>
            <div class="atBottom">
                <button mat-raised-button (click)="enviarCamp()"  class="cta-button" style="margin-left: 10px;"  color="accent">
                  Enviar campaña
                </button>
            </div>
            </mat-card-content>

        </mat-card>
    </div>
        
    
        
</div>
<div *ngIf="loading" class="fuse-navy">
    <app-loading></app-loading>
</div>-->



<style>
    body {
        font-family: Arial, sans-serif;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #f4f4f9;
        margin: 0;
        padding: 20px;
    }
    h1 {
        color: #333;
    }
    .form-container {
        background-color: #fff;
        padding: 20px;
        border-radius: 8px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        width: 100%;
        max-width: 600px;
        margin-bottom: 20px;
    }
    .form-group {
        display: flex;
        align-items: center;
        margin-bottom: 15px;
    }
    .form-group label {
        flex: 2;
        margin-right: 10px;
        color: #555;
    }
    .form-group input {
        flex: 1;
        padding: 8px;
        border: 1px solid #ccc;
        border-radius: 4px;
    }
    .form-group span {
        font-size: 12px;
        color: #888;
    }
    #myChart {
        max-width: 800px;
        width: 100%;
    }
    #generate {
        margin-top: 20px;
        padding: 10px 20px;
        background-color: #3498db;
        color: #fff;
        border: none;
        border-radius: 4px;
        cursor: pointer;
    }
    #summary {
        display: none;
        margin-top: 20px;
        padding: 10px 20px;
        background-color: #3498db;
        color: #fff;
        border: none;
        border-radius: 4px;
        cursor: pointer;
    }
</style>
<body>

<h1>Análisis de campaña global</h1>
<div class="form-container">
    <div class="form-group">
        <label for="presupuesto">Presupuesto:</label>
        <input  readonly type="number" id="presupuesto" min="0" max="100" value="70">
        <span>% (100 mucho interes y 0 poco interes)</span>
    </div>
    <div class="form-group">
        <label for="autoridad">Autoridad:</label>
        <input  readonly type="number" id="autoridad" min="0" max="100" value="80">
        <span>% (100 mucho interes y 0 poco interes)</span>
    </div>
    <div class="form-group">
        <label for="necesidad">Necesidad:</label>
        <input  readonly type="number" id="necesidad" min="0" max="100" value="60">
        <span>% (100 mucho interes y 0 poco interes)</span>
    </div>
    <div class="form-group">
        <label for="tiempo">Tiempo:</label>
        <input  readonly type="number" id="tiempo" min="0" max="100" value="50">
        <span>% (100 mucho interes y 0 poco interes)</span>
    </div>
    <div class="form-group">
        <label for="quiereReunion">Quiere reunión comercial:</label>
        <input  readonly type="number" id="quiereReunion" min="0" max="100" value="30">
        <span>% (100 mucho interes y 0 poco interes)</span>
    </div>
    <div class="form-group">
        <label for="agendadaReunion">Agendada reunión comercial:</label>
        <input  readonly type="number" id="agendadaReunion" min="0" max="100" value="20">
        <span>% (100 mucho interes y 0 poco interes)</span>
    </div>
    <button id="generate" (click)="generateDiagram()">Generar Diagrama</button>
</div>

<canvas id="myChart"></canvas>
<button id="summary" style="display:none;" (click)="generateSummary()">Resumen</button>



</body>
